import { baseURL } from './baseURL'
import { apiRoutes, post } from './apiRoutes'
import * as schema from './schema/nodeServer'
import i18n from '@/i18n'
import { getDestinationHeader } from '@/utils/api_destination_header'

const defaultHeaders = {
  Authorization: undefined as string | undefined,
  'Accept-Language': i18n.locale,
  'X-VLIVE-CLIENT-TYPE': 'webapp',
  ...getDestinationHeader(),
}

export default apiRoutes(
  baseURL,
  defaultHeaders
)({
  loggingAccess: {
    _: post<schema.AccessLogParam, void>(),
  },
  feedback: {
    _: post<schema.UserWebFeedbackLog, void>(),
  },
})
